<template>
  <v-container fluid>
      <h3>자주 묻는 질문(FAQ)</h3>


    <v-row>
      <v-col>
        <v-expansion-panels
            inset
            focusable
            multiple
        >
          <v-expansion-panel
              v-for="faq in faqList"
              :key="faq.id"
          >
            <v-expansion-panel-header>{{ faq.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ faq.answer }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'Board',
  components: {},
  data() {
    return {
      isShowBoard: false,
      selectedRow: {},

      faqList: [
        {
          id: 1,
          question: 'aaa',
          answer: 'bbb'
        },
        {
          id: 2,
          question: 'aaa2',
          answer: 'bbb2'
        }
      ],
      total: 1
    };
  },
  computed: {
    ...mapGetters(['app', 'user']),
  },
  methods:{
    searchPosts(){
      this.searchQuery.boardType = 'FAQ'
      this.searchQuery.page = this.page - 1

      // return apiBoard.getBoardPage(this.searchQuery)
      //     .then(res => {
      //       this.faqList = res.content
      //       this.total = res.totalPages
      //     })
      //     .finally(() => this.listLoading = false)
    }
  }
};
</script>
